import { render, staticRenderFns } from "./ModalAttendanceType.vue?vue&type=template&id=fdda0072&"
import script from "./ModalAttendanceType.vue?vue&type=script&lang=js&"
export * from "./ModalAttendanceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports